import clsx from 'clsx';
import { tlwTwMerge } from '@trg/utils';
import { Link, type LinkProps } from '@trg/tlw-ui-component';
import { useProductCardContext } from './ProductCardContext';
import { ProductCardPreview } from './ProductCardPreview';
import { PriceDetail } from '../PriceDetail';

export function ProductCardForSimple({
  className,
  children,
  ...props
}: LinkProps) {
  const { product, isVertical, isHorizontal } = useProductCardContext();

  const disabled = product.stockLevel === 0;

  return (
    <Link
      className={tlwTwMerge(
        'tlw-group/product-card tlw-card-shadow-product tlw-grid tlw-bg-white tlw-rounded-lg tlw-overflow-hidden',
        isVertical && 'tlw-grid-rows-[auto_1fr]',
        isHorizontal && 'tlw-grid-cols-[auto_1fr] tlw-auto-rows-[100%]',
        className
      )}
      href={product.link}
      {...props}
    >
      {/* Preview 區域 */}
      <div className="tlw-aspect-square tlw-relative tlw-max-w-full tlw-max-h-full tlw-bg-gray-200 tlw-overflow-hidden">
        {/* 商品圖 */}
        <ProductCardPreview />
      </div>

      {/* Introduction 區域 */}
      <div
        className={clsx(
          'tlw-relative tlw-flex tlw-flex-col tlw-gap-2 tlw-overflow-hidden',
          isVertical && 'tlw-p-2 lg:tlw-p-4',
          isHorizontal && 'tlw-px-2 tlw-py-1.5 lg:tlw-px-4 lg:tlw-py-3'
        )}
      >
        {/* 商品名 */}
        <p
          className={clsx(
            'tlw-txt-zh-head-7 tlw-line-clamp-2 tlw-h-[45px] lg:tlw-h-12',
            disabled ? 'tlw-text-txt-500' : 'tlw-text-txt-700'
          )}
        >
          {product.name}
        </p>

        {/* 商品價格 */}
        <PriceDetail
          listPrice={product.listPrice}
          salePrice={product.salePrice}
          pointPrice={product.pointPrice}
          pointPriceName={product.pointPriceName}
          overturn={isVertical}
          disabled={disabled}
        />

        {children}
      </div>
    </Link>
  );
}
